module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 1.25C7.58375 1.25 5.625 3.20875 5.625 5.625L5.625 8.75C4.58947 8.75 3.75 9.58947 3.75 10.625V16.875C3.75 17.9105 4.58947 18.75 5.625 18.75H14.375C15.4105 18.75 16.25 17.9105 16.25 16.875V10.625C16.25 9.58947 15.4105 8.75 14.375 8.75V5.625C14.375 3.20875 12.4162 1.25 10 1.25ZM12.5 8.75V5.625C12.5 4.24429 11.3807 3.125 10 3.125C8.61929 3.125 7.5 4.24429 7.5 5.625V8.75H12.5Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
